import { Link, RemoveIcon } from '@dreryk/react-components';

import { SentPrescriptionAnnulmentConfirmationEventInterceptor } from './SentPrescriptionAnnulmentConfirmationEventInterceptor';

type SentPrescriptionAnnulmentLinkProps = {
   readonly disabled: boolean;
   readonly prescriptionId: string;
   readonly visitId: number;
};

export const SentPrescriptionAnnulmentLink = (props: SentPrescriptionAnnulmentLinkProps): JSX.Element => {
   return (
      <SentPrescriptionAnnulmentConfirmationEventInterceptor
         prescriptionId={props.prescriptionId}
         visitId={props.visitId}
      >
         <Link disabled={props.disabled} testId={'sentPrescriptionAnnulment'} icon={<RemoveIcon />} />
      </SentPrescriptionAnnulmentConfirmationEventInterceptor>
   );
};
